import React, { useEffect, useMemo, useState } from 'react';
import { translate } from '../../Services/translation';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Icon from '../Icon';
import OrderDetail from '../OrderDetail/OrderDetailMyOrder';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { reorderFromNavisionOrder } from '../../Services/Cart.service';
import { receive, loadError } from '../../Actions/Cart.action';
import { catchError } from '../../Actions/Error.action';
import { getOrder } from '../../Actions/Invoices.action';

const MyPagesOrderDetail = () => {
  const navigate = useNavigate();
  const { id, nav } = useParams();
  const dispatch = useDispatch();
  const [order, setOrder] = useState();

  const fetchOrder = async () => {
    var data = await getOrder(id);
    setOrder(data);
  };

  useEffect(() => {
    if (!order) {
      fetchOrder();
    }
  }, []);

  const addOrderToCart = async () => {
    try {
      const cart = await reorderFromNavisionOrder(id);
      dispatch(receive(cart));
      return true;
    } catch (ex) {
      dispatch(catchError(ex, (error) => loadError(error)));
      return false;
    }
  };

  return (
    <div className="col-span-3">
      <div className="mb-4 flex gap-2 md:justify-between lg:mb-6">
        <button
          className="btn btn--small btn--outline flex-1 md:flex-initial"
          onClick={() => {
            navigate(-1);
          }}
        >
          <Icon name="chevron-left" className="order-icon" />
          {translate('mypage.order.allorders')}
        </button>
        <div className="flex flex-1 gap-2 md:flex-initial md:gap-6">
          <button
            className="btn btn--outline btn--small flex w-full items-center justify-center md:w-fit"
            onClick={addOrderToCart}
          >
            <Icon name="refresh" className="order-icon" />
            {translate('mypage.order.addtocart')}
          </button>
        </div>
      </div>
      {order && <OrderDetail order={order} isConfirmation={false} />}
    </div>
  );
};

export default MyPagesOrderDetail;
